import languagesConfig from '@datacamp/dc-languages-config';
import { AutoCompletionKind } from '../types';
const SPLIT_TOKENS_REGEX = /[^a-zA-Z_0-9$\-\u00C0-\u1FFF\u2C00-\uD7FF\w]+/;
const stripCommentsFromCode = (code, commentRegexes) => {
  if (commentRegexes == null) {
    return code;
  }
  return commentRegexes.reduce((strippedCode, commentRegex) => {
    return strippedCode.replace(commentRegex, '');
  }, code);
};
const splitCodeIntoTokens = code => {
  return code.split(SPLIT_TOKENS_REGEX);
};
const removeDuplicateTokens = tokens => {
  const tokensWithoutBlanks = tokens.filter(token => token.length > 0);
  const deduplicatedTokens = new Set(tokensWithoutBlanks);
  return [...deduplicatedTokens];
};
const removeCompletionString = (completionString, tokens) => {
  return tokens.filter(token => token !== completionString);
};
const extractAutoCompletionsFromCode = (code, completionString, language) => {
  const codeWithCommentsStripped = stripCommentsFromCode(code, languagesConfig[language].completerIgnoreRegexArr);
  const splitIntoTokens = splitCodeIntoTokens(codeWithCommentsStripped);
  const withDuplicatesRemoved = removeDuplicateTokens(splitIntoTokens);
  const extractedTokens = removeCompletionString(completionString, withDuplicatesRemoved);
  return extractedTokens.map(suggestion => {
    return {
      additionalDetail: 'local',
      kind: AutoCompletionKind.Value,
      label: suggestion,
      textToInsert: suggestion
    };
  });
};
const createTextAutoCompletionProvider = () => {
  return {
    provideCompletionItems: _ref => {
      let {
        fullEditorText,
        language,
        wordAtPosition: word
      } = _ref;
      return Promise.resolve(extractAutoCompletionsFromCode(fullEditorText || '', word.word, language));
    }
  };
};
export default createTextAutoCompletionProvider;